import React, { useEffect, useState } from 'react'

import "./core-dropdown.css"
import { getGlobalTextSizeStyle, TextHtmlTagType } from '../../../../misc/tools';

const CoreDropdown = (props: CoreDropdownConfig) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const [selectedIndex, setSelectedIndex] = useState(props.defaultSelectedIndex ?? props.canSelectNothing ? -1 : 0);
	const [isInitialized, setIsInitialized] = useState(false);
	const onDropdownClicked = () => {
		setIsExpanded(!isExpanded);
	};

	useEffect(() => {
		const onWindowClick = () => {
			if(isExpanded) {
				setIsExpanded(false);
			}
		}
		if(!isInitialized) {
			setTimeout(() => {
				window.addEventListener('click', onWindowClick);
			}, 0);

			if(props.canSelectNothing) {
				props.items.splice(0, 0, '(Nothing)')
			}

			setIsInitialized(true);
		}

		return () => {
			window.removeEventListener('click', onWindowClick);
		}
	}, [])

	return (
		<div className="core-dropdown-root modal-disable-select">
			<div className='core-dropdown-selection-container' onClick={onDropdownClicked}>
				{selectedIndex === -1 ? <p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text'>{props.placeholderText ?? 'Select Item'}</p> : null}
				{selectedIndex !== -1 ? <p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text'>{props.items[selectedIndex]}</p> : null}
			</div>
			{isExpanded ? <div className='core-dropdown-options-container'>
				{props.items.map((item: number | string, index: number) => {
					return (
						<div className='core-dropdown-options-single-item-container' onClick={() => {
							setIsExpanded(false);
							setSelectedIndex(index);
							props.onItemSelected(item, index);
						}}>
							<p style={{...getGlobalTextSizeStyle(TextHtmlTagType.p)}}className='default-text'>{item}</p>
						</div>
					)
				})}
			</div> : null }
		</div>
	);

};

export interface CoreDropdownConfig {
	items: number[] | string[];
	placeholderText: string;
	defaultSelectedIndex: number;
	canSelectNothing: boolean;
	onItemSelected: (item: number | string, index: number) => void;
}

export default CoreDropdown;